export default __webpack_public_path__ + "static/media/tile_users.c89403b2.jpg";